/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateReview200ResponseAllOfData } from './CreateReview200ResponseAllOfData';
import {
    CreateReview200ResponseAllOfDataFromJSON,
    CreateReview200ResponseAllOfDataFromJSONTyped,
    CreateReview200ResponseAllOfDataToJSON,
} from './CreateReview200ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateReview200Response
 */
export interface CreateReview200Response {
    /**
     * 
     * @type {CreateReview200ResponseAllOfData}
     * @memberof CreateReview200Response
     */
    data: CreateReview200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof CreateReview200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the CreateReview200Response interface.
 */
export function instanceOfCreateReview200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function CreateReview200ResponseFromJSON(json: any): CreateReview200Response {
    return CreateReview200ResponseFromJSONTyped(json, false);
}

export function CreateReview200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReview200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateReview200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function CreateReview200ResponseToJSON(value?: CreateReview200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateReview200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

